// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EpisodeDemographics_wrapper__21VU3","container":"EpisodeDemographics_container__-xRhu"};